<template>
  <div class="group-item">
    <div class="tagGroupArr">
      <p class="tagGroupName">
        <span>按条件发送</span>
      </p>
      <hr style="border: 0.5px solid #eeeeee" />
      <div class="usedGroup-content">
        <div v-for="(el, index) in tagGroupArr" :key="index" class="items">
          {{ el.key }} : {{ el.val || '---' }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    tagGroupArr: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      tags: {
        consumptionFieldMap: this.$t('tagsManagement.spending_model'),
        activeFieldMap: this.$t('tagsManagement.behavior_model'),
        basicFieldMap: this.$t('tagsManagement.attribute_attribute')
      }
    };
  }
};
</script>
<style lang="scss">
.tagGroupName {
  font-weight: 600;
}
.group-item {
  .itemTitle {
    color: #3e8bc6;
    margin-top: 10px;
    margin-bottom: 5px;
  }
  .items-labes {
    line-height: 24px;
  }
}
.tagGroupArr {
  margin-top: 20px;
  .tagGroupName {
    font-weight: 600;
  }
  .usedGroup-content {
    .items {
      margin-bottom: 10px;
      line-height: 20px;
    }
  }
}
</style>
